import styled from '@emotion/styled';
import { captionM, tag1Sb, tag2 } from '@teamsparta/stack-font';

import { DESKTOP } from '@/styles/themes';

export const Progress = styled.div`
  margin-top: 1.5rem;
  max-width: 404px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
`;

export const ProgressText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const Text = styled.span`
  width: 40px;
  ${tag1Sb};
  color: #009f65;

  ${DESKTOP} {
    ${captionM};
    color: #009f65;
  }
`;

export const ProgressBarWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 22px;
  border-radius: 9999px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border: 1px solid #b9e1d2;
  background: #f4f8f1;
  box-shadow: 1px 1px 4px 0px rgba(9, 158, 9, 0.2) inset;
`;

export const ProgressBar = styled.div<{ progress: number }>`
  width: ${({ progress }) => `${progress}%`};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  background: linear-gradient(90deg, #02734a -61.38%, #04d98b 195.96%);
  box-shadow: 1px -4px 4px 0px rgba(0, 0, 0, 0.1) inset;
  border-radius: 42px;
  transition: width 0.3s ease;

  ${tag2};
  color: black;
`;

export const ProgressCount = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  color: rgba(0, 71, 45, 0.9);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: Pretendard;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 15px;
`;
